/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanySummaryV2Dto } from './companySummaryV2Dto';
import { PersonalizationDto } from './personalizationDto';
import { PlaceInformationDto } from './placeInformationDto';
import { LocationSummaryV2Dto } from './locationSummaryV2Dto';


export interface LoyaltyProgramDetailV2Dto { 
    id?: number;
    displayName?: string;
    logo?: string;
    currency?: string;
    priceToPointsRatio?: number;
    dailyLimit?: number;
    govQrCodeAvailable?: boolean;
    status?: LoyaltyProgramDetailV2Dto.StatusEnum;
    personalization?: PersonalizationDto;
    company?: CompanySummaryV2Dto;
    placeInformation?: PlaceInformationDto;
    primaryLocation?: LocationSummaryV2Dto;
    showLocations?: boolean;
}
export namespace LoyaltyProgramDetailV2Dto {
    export type StatusEnum = 'INVALID' | 'IN_PROGRESS' | 'VALID';
    export const StatusEnum = {
        Invalid: 'INVALID' as StatusEnum,
        InProgress: 'IN_PROGRESS' as StatusEnum,
        Valid: 'VALID' as StatusEnum
    };
}


